export default __webpack_public_path__ + "static/C4_Remote_Detonator-49c204e5d42a6c5634af502215bf2377.png";